module.exports = __webpack_public_path__ + "img/699-b6095a.png";